import i18n from 'i18next';

export const InitialStep = 1;
export const PlayingStep = 2;

export const CUSTOMIZE_IMAGE_ICON_MODE = 'customizeImageIcon';
export const CUSTOMIZE_IMAGE_MODE = 'customizeImage';
export const CUSTOMIZE_IMAGE_ICON_MODE_TAB = 0;
export const CUSTOMIZE_IMAGE_MODE_TAB = 1;

export const VISION_LOGO_BTN_MODE = 'logoBtn';
export const VISION_IMAGE_MODE = 'customizeImage';
export const VISION_LOGO_BTN_MODE_TAB = 0;
export const VISION_IMAGE_MODE_TAB = 1;

// 按鈕模式
export const BTN_CUSTOMIZE_IMAGE_MODE = 'customizeImage';
export const BTN_WHITEBOARD_MODE = 'whiteboard';
export const BTN_WHITEBOARD_MODE_TAB = 0;
export const BTN_CUSTOMIZE_IMAGE_MODE_TAB = 1;

// focus
export const FOCUS_VISION_LOGO = 'focusVisionLogo';
export const FOCUS_VISION_BTN = 'focusVisionBtn';
export const FOCUS_VISION_IMAGE = 'focusVisionImage';
export const FOCUS_RED_ENVELOPE_IMAGE_ICON = 'focusCustomizeImageIcon';
export const FOCUS_RED_ENVELOPE_IMAGE = 'focusCustomizeImage';
export const FOCUS_DECORATE_IMAGES = 'focusDecoratImages';

// image resource
export const openEffectImg = 'https://assets.fevercdn.com/promotion/img/red_envelope_effect.svg';
export const redEvelopeImg = 'https://assets.fevercdn.com/promotion/img/red_envelope_prize.svg';
export const redEvelopeBackgroundImg =
    'https://assets.fevercdn.com/promotion/img/red_envelope_background.png';
export const redEvelopeMbBackgroundImg =
    'https://assets.fevercdn.com/promotion/img/red_envelope_mbbackground.png';

export const generateInitialSetting = () => {
    return {
        redEnvelopeSetting: {
            customImage: '',
            // 自訂紅包
            imageIcon: 'https://assets.fevercdn.com/promotion/img/red_envelope_icon.svg',
            // 紅包 icon
            mode: CUSTOMIZE_IMAGE_ICON_MODE
            // 選用模式 自訂紅包 || 紅包 icon
        },
        initialDecorateImageSetting: {
            show: true
            // 起始畫面顯示點綴物
        },
        decorateImageSetting: {
            images: [
                'https://assets.fevercdn.com/promotion/img/red_envelope_decorate_1.svg',
                'https://assets.fevercdn.com/promotion/img/red_envelope_decorate_2.svg'
            ]
            // 點綴物 images
        },
        visionSetting: {
            mode: VISION_LOGO_BTN_MODE,
            // 主題視覺 預設樣式 ( logo btn ) || 自訂樣式 ( image block )
            visionImage: '',
            // 自訂樣式 圖片 ( image block )
            mainImage: 'https://assets.fevercdn.com/promotion/img/red_envelope_logo.svg',
            // logo 圖片
            showMainImage: true,
            // 顯示 logo 圖片
            btnMode: BTN_WHITEBOARD_MODE,
            // 按鈕模式 預設樣式 ( 按鈕 text, color, bgColor ) || 客製樣式 ( btnImage )
            showBtn: true,
            // 按鈕是否顯示
            btnText: i18n.t('label.start_game'),
            // 按鈕 文字
            btnTextColor: '#fff',
            // 按鈕 文字顏色
            btnBgColor: '#9D0100',
            // 按鈕 背景顏色
            btnImage: ''
            // 按鈕 客製化圖片
        }
    };
};
